import { render } from "./FormPL.vue?vue&type=template&id=6ba49bef"
import script from "./FormPL.vue?vue&type=script&lang=js"
export * from "./FormPL.vue?vue&type=script&lang=js"

import "./FormPL.vue?vue&type=style&index=0&id=6ba49bef&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__